import InvestmentSteps from "./InvestmentSteps"

export default InvestmentSteps
